export default __webpack_public_path__ + "static/media/post-09-detail.85684fef.jpg";